import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Search, Download, ChevronUp, ChevronDown } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface DentistFiltersData {
  nameLike?: string;
  pageSize?: number;
}

interface DentistFiltersProps {
  onFilterChange: (filters: DentistFiltersData) => void;
  includeInactive: boolean;
  onIncludeInactiveChange: (value: boolean) => void;
}

export function DentistFilters({
  onFilterChange,
  includeInactive,
  onIncludeInactiveChange,
}: DentistFiltersProps) {
  const [showFilters, setShowFilters] = useState(true);
  const [nameLike, setNameLike] = useState<string>("");
  const [pageSize, setPageSize] = useState<string>("20");

  const handleFilter = () => {
    onFilterChange({
      nameLike: nameLike || undefined,
      pageSize: parseInt(pageSize),
    });
  };

  const handleClearFilters = () => {
    setNameLike("");
    setPageSize("20");
    onIncludeInactiveChange(false);
    onFilterChange({});
  };

  return (
    <div className="space-y-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setShowFilters(!showFilters)}
        className="filter-toggle"
      >
        {showFilters ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
        {showFilters ? "Esconder Filtros" : "Mostrar Filtros"}
      </Button>

      {showFilters && (
        <div className="filter-box">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
            <div className="space-y-1">
              <Label htmlFor="nameLike" className="filter-label">Nome (parcial)</Label>
              <Input
                id="nameLike"
                placeholder="Digite parte do nome"
                className="filter-input"
                value={nameLike}
                onChange={(e) => setNameLike(e.target.value)}
              />
            </div>

            <div className="space-y-1">
              <Label htmlFor="pageSize" className="filter-label">Registros por Página</Label>
              <Select value={pageSize} onValueChange={setPageSize}>
                <SelectTrigger id="pageSize" className="filter-input">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-popover z-50">
                  <SelectItem value="10">10</SelectItem>
                  <SelectItem value="20">20</SelectItem>
                  <SelectItem value="50">50</SelectItem>
                  <SelectItem value="100">100</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex items-center gap-2">
              <Checkbox
                id="includeInactive"
                checked={includeInactive}
                onCheckedChange={onIncludeInactiveChange}
              />
              <Label htmlFor="includeInactive" className="filter-label cursor-pointer">
                Incluir inativos
              </Label>
            </div>

            <div className="flex gap-2">
              <Button size="sm" onClick={handleFilter} className="flex-1 btn-header">
                <Search className="btn-header-icon" /> Filtrar
              </Button>
              <Button size="sm" variant="outline" onClick={handleClearFilters} className="flex-1 btn-header">
                Limpar
              </Button>
              <Button size="sm" variant="outline" className="btn-header">
                <Download className="btn-header-icon" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
